module.exports = "<div class=\"content\">\n  <img alt=\"Warpkode\" src=\"assets/w.png\">\n</div>\n\n\n"